import { Pipe, PipeTransform } from '@angular/core';
import { TaxRatesService } from './tax-rates.service';
import { Price, PriceDesc } from '../interfaces/price.interface';

@Pipe({
    name: 'taxRate',
    pure: true,
})
export class TaxRatePipe implements PipeTransform {
    constructor(
        private taxRatesService: TaxRatesService,
    ) {}

    transform(value: any, price: Price | PriceDesc): any {
        if (!value || !price) {
            return value;
        }
        if (!price.resetTaxRate) {
            return value;
        }
        const defaultTaxRate = this.taxRatesService.getDefaultTaxRate();
        return TaxRatesService.recalcPrice(
            price.isGross,
            value,
            price.isGross,
            price.taxRate,
            defaultTaxRate?.value
        );
    }
}
